module.exports = __webpack_public_path__ + "static/media/award03.6e5c05a0.jpeg";